import script from "./SideNavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNavItem.vue?vue&type=script&setup=true&lang=js"

import "./SideNavItem.vue?vue&type=style&index=0&id=5c1af81c&lang=css"

const __exports__ = script;

export default __exports__